module.exports = __webpack_public_path__ + "static/img/RiskScan.55a9e98b.png";